import { createSlice } from "@reduxjs/toolkit";
import { adPlacementDetailsHandler } from "../services/operations/adPlacementDetailsAPI";

const initialState = {
  content: {
    content_url: {
      Watermark: null
    },
    video_mention: {
      data: ""
    },
    in_content_ad_placements: [],
    position_options_watermark: "", 
  },
  available_placements: [],
  deadline: "",
  loading: false,
  error: null
};

const adPlacementDetailsSlice = createSlice({
  name: "adPlacementDetails",
  initialState,
  reducers: {
    resetAdPlacementDetails: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(adPlacementDetailsHandler.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(adPlacementDetailsHandler.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        
        if (action.payload) {
          // If we have content in the response, update content
          if (action.payload.content) {
            state.content = action.payload.content;
          }
          
          // If we have deadline in the response, update deadline
          if (action.payload.deadline) {
            state.deadline = action.payload.deadline;
          }
          
          // Update available_placements if it exists in the response
          if (action.payload.available_placements) {
            state.available_placements = action.payload.available_placements;
          }
        }
      })
      .addCase(adPlacementDetailsHandler.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export const { resetAdPlacementDetails } = adPlacementDetailsSlice.actions;

export default adPlacementDetailsSlice.reducer;